import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import "./allSubscriptionsModal.css";
import { useParams } from "react-router-dom";
import { KeyboardArrowDown } from "@material-ui/icons";
import { createUserSubscription } from "../../services/user.services";
import { getAllSubscriptionsType } from "../../services/subscriptions.services";

const initialState = {
  subscriptionName: "",
  cost: "",
  type: "",
  durationDays: "",
};

export default function AddSubscriptionModal({
  props,
  data,
  setSelectedClockType,
  clockTypeModal,
}) {
  const { userId } = useParams();

  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    handleFormChange("userId", userId);
  }, []);

  return (
    <React.Fragment>
      <Button onClick={handleOpen}>
        <KeyboardArrowDown name="chevron-down" style={{ fontSize: 30 }} />
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box className="muiAllSubModalStyle">
          <div className="allSubModalMain">
            {data &&
              data.length > 0 &&
              data.map((val, ind) => {
                return (
                  <button
                    className="allSubModalOptions"
                    onClick={() => {
                      setSelectedClockType(val);
                      handleClose();
                    }}
                  >
                    <text key={ind} className="allSubModalLabel">
                      {val}
                    </text>
                  </button>
                );
              })}
          </div>
        </Box>
      </Modal>
    </React.Fragment>
  );
}
